// BetaTech: quantity rules (minimum / maximum / increment) shared by every quantity input.
// Rules are rendered by Liquid from variant.quantity_rule into the input's min / max / step
// attributes. Retail variants are always min 1, no max, step 1, so retail behaviour is unchanged.
window.BetaQuantity = {
  read(input) {
    const toInt = (value) => {
      const number = parseInt(value, 10);
      return Number.isInteger(number) && number > 0 ? number : null;
    };

    return {
      min: toInt(input && input.min) || 1,
      max: toInt(input && input.max),
      step: toInt(input && input.step) || 1,
    };
  },

  // Snaps a value to a valid quantity: at least min, a multiple of step, at most max.
  // allowZero keeps 0 as-is (cart lines: 0 removes the line).
  normalize(value, rule, allowZero = false) {
    let qty = parseInt(value, 10);
    if (allowZero && qty === 0) return 0;
    if (!Number.isInteger(qty) || qty < rule.min) qty = rule.min;

    qty = Math.ceil(qty / rule.step) * rule.step;
    if (rule.max !== null && qty > rule.max) {
      qty = Math.floor(rule.max / rule.step) * rule.step;
    }

    return Math.max(qty, rule.min);
  },

  // direction: 1 or -1. Never goes below min (removing a cart line is done with the remove button).
  step(value, direction, rule) {
    const current = parseInt(value, 10) || rule.min;
    return this.normalize(current + direction * rule.step, rule);
  },

  // Applies a variant's quantity_rule (from variant JSON) to an input, when the payload has one.
  apply(input, quantityRule) {
    if (!input || !quantityRule) return;
    input.min = quantityRule.min || 1;
    input.step = quantityRule.increment || 1;
    if (quantityRule.max) {
      input.max = quantityRule.max;
    } else {
      input.removeAttribute('max');
    }
  },
};
